import { type MouseEvent } from 'react';

export default function Footer() {
  const handleScroll = (e: MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-background-900 text-white">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl font-heading text-primary-400">黑料爆料</span>
              <span className="text-xs bg-primary-500/30 text-primary-300 px-2 py-0.5 rounded-full whitespace-nowrap">吃瓜网</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              专注娱乐圈八卦与明星黑料的资讯聚合平台。51吃瓜与17c黑料爆料实时同步，为吃瓜群众提供最新鲜热门的瓜田每日更新。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门模块</h4>
            <nav className="flex flex-col gap-2">
              {[
                { label: '今日热瓜', href: '#index' },
                { label: '吃瓜热度榜', href: '#ranking' },
                { label: '实时快讯', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '焦点深扒', href: '#carousel' },
                { label: '深度爆料', href: '#cards' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关于我们</h4>
            <nav className="flex flex-col gap-2">
              {[
                { label: '吃瓜必读', href: '#faq' },
                { label: '为什么选择我们', href: '#features' },
                { label: '关于黑料爆料', href: '#about' },
                { label: '投稿爆料', href: '#contact' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => handleScroll(e, item.href)}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-wechat-line text-white text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-weibo-line text-white text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-full bg-background-700 flex items-center justify-center cursor-pointer hover:bg-primary-600 transition-colors">
                <i className="ri-tiktok-line text-white text-sm"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 黑料爆料吃瓜网 - 理性吃瓜，快乐每一天
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span className="cursor-pointer hover:text-foreground-200 transition-colors whitespace-nowrap">隐私政策</span>
            <span className="cursor-pointer hover:text-foreground-200 transition-colors whitespace-nowrap">免责声明</span>
            <span className="cursor-pointer hover:text-foreground-200 transition-colors whitespace-nowrap">内容投诉</span>
          </div>
        </div>
      </div>
    </footer>
  );
}